import { render } from "./ReminderDailyChart.vue?vue&type=template&id=63eb86e1&scoped=true"
import script from "./ReminderDailyChart.vue?vue&type=script&lang=js"
export * from "./ReminderDailyChart.vue?vue&type=script&lang=js"

import "./ReminderDailyChart.vue?vue&type=style&index=0&id=63eb86e1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63eb86e1"]])

export default __exports__